module.exports = __webpack_public_path__ + "static/media/linea_1.8c3e23b0.svg";